import { POApi } from "@pulseops/common"
import * as t from 'io-ts'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from "@mxt/zio"
import { Maybe } from "@mxt/zio/codec"

export namespace DAAdditionalInformationService {

  const EKYDInfo = t.type({
    fieldTypeEKYD: t.string,
    fieldTypeSubmission: t.string,
    fieldTypeDisplay: t.string,
    submission: Maybe(t.string),
    resultMatching: t.string,
    ekyd: t.string,
  })

  const AdditionalInformationResponse = Maybe(t.type({
    interviewInfo: t.type({
      faceMatchingResult: t.string,
      interviewTime: t.string,
      interviewerFullName: t.string,
      timeUpdateResult: t.string,
      interviewResult: t.string
    }),
    candidateAssessmentInfo: t.type({
      agentLeaderFullName: t.string,
      approveDateOfAgentLeader: t.string,
      approveStatusOfAgentLeader: t.string,
      approveDateOfBDM: t.string,
      approveStatusOfBDM: t.string,
      reApproveDateByBDM: t.string,
      reApproveStatusByBDM: t.string,
      interviewerFullName: t.string,
      approveNotHaveDiploma: t.string,
      comment: t.string
    }),
    ekydVerifyInfo: t.type({
      integrity: t.string,
      authenticationCCCD: t.string,
      faceMatchingNFC: t.string,
      faceMatchingResult: t.string
    }),
    ekydInfos: t.array(EKYDInfo)
  }))

  export type AdditionalInformationResponse = t.TypeOf<typeof AdditionalInformationResponse>

  export const getAdditionalInformationFromPruforce = (businessKey: string) => {
    return pipe(
      POApi.get(`distribution-agents-service/additional-info/interview/${businessKey}`)(AdditionalInformationResponse),
      ZIO.map((additionInfo) => additionInfo)
    )
  }
}